import { render, staticRenderFns } from "./list-faltas.vue?vue&type=template&id=0f1b80b6"
import script from "./list-faltas.vue?vue&type=script&lang=js"
export * from "./list-faltas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports